angular.module("app").directive("editor", [
    '$timeout',
    function ($timeout) {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (scope, element, attrs, ngModel) {
                var editor = CKEDITOR.replace( 'editor', {extraPlugins: 'imageuploader'}),
                    seted = false,
                    watcher = function () {};

                attrs.editor && (watcher = attrs.$observe("editor", function (val) {
                    if (!!val && !seted) {
                        seted = true;
                        setValue();
                    }
                })) || setValue();

                editor.on("change", function (evt) {
                    $timeout(function () {
                        ngModel.$setViewValue(evt.editor.getData())
                    })
                });

                function setValue () {
                    watcher();
                    editor.setData(ngModel.$modelValue || ngModel.$viewValue || "");
                }

                scope.$on("force:reset:editor", function () {
                    $timeout(setValue)
                })
            }
        }
    }
]);